// BonBoZ: logic thuần của thẻ kết bạn Zalo + panel "Cuộc trò chuyện mới".
// Tách khỏi .vue để test được. Hợp đồng dữ liệu: content_attributes
// `bonboz_zalo_ket_ban` / `bonboz_zalo_huy_ket_ban` (đã camelCase).
import { format, isSameDay } from 'date-fns';
import { boDau } from './boDau';

const P = 'BONBOZ.KET_BAN';

/** Khoá i18n của pill theo trạng thái + hướng. */
export const khoaPill = (trangThai, huong) => {
  if (trangThai === 'cho')
    return `${P}.PILL.${huong === 'den' ? 'CHO_BAN' : 'CHO_KHACH'}`;
  if (trangThai === 'dong_y') return `${P}.PILL.DONG_Y`;
  if (trangThai === 'tu_choi')
    return `${P}.PILL.${huong === 'den' ? 'DA_TU_CHOI' : 'KHACH_TU_CHOI'}`;
  if (trangThai === 'thu_hoi') return `${P}.PILL.THU_HOI`;
  return `${P}.PILL.HUY_KET_BAN`;
};

/** Màu pill: amber chờ, teal bạn bè, ruby từ chối, còn lại xám. */
export const mauPill = trangThai =>
  ({
    cho: 'bg-n-amber-3 text-n-amber-11',
    dong_y: 'bg-n-teal-3 text-n-teal-11',
    tu_choi: 'bg-n-ruby-3 text-n-ruby-11',
  })[trangThai] || 'bg-n-slate-3 text-n-slate-11';

/** Chấm màu của từng bước. */
export const mauBuoc = loai =>
  ({
    gui: 'bg-n-blue-9',
    dong_y: 'bg-n-teal-9',
    tu_choi: 'bg-n-ruby-9',
  })[loai] || 'bg-n-slate-8';

/** Nhãn quote; null = ẩn (lời nhắn rỗng). */
export const khoaNhanLoiNhan = (huong, loiNhan) => {
  if (!loiNhan) return null;
  return `${P}.LOI_NHAN.${huong === 'den' ? 'CUA_KHACH' : 'CUA_BAN'}`;
};

/** { key, params } cho một bước. `huong` của thẻ quyết định bước "gui". */
export const chuBuoc = ({ loai, boi }, huong, tenKhach) => {
  const ai = { ban: 'BAN', zalo: 'ZALO' }[boi] || 'KHACH';
  const params = { ten: tenKhach || '' };
  if (loai === 'gui')
    return {
      key: `${P}.BUOC.GUI_${huong === 'den' ? 'KHACH' : 'BAN'}`,
      params,
    };
  if (loai === 'dong_y' || loai === 'tu_choi')
    return { key: `${P}.BUOC.${loai.toUpperCase()}_${ai}`, params };
  if (loai === 'thu_hoi') return { key: `${P}.BUOC.THU_HOI`, params };
  return { key: `${P}.BUOC.HUY_KET_BAN`, params };
};

/** HH:mm nếu hôm nay, dd/MM HH:mm nếu khác ngày. */
export const gioBuoc = (iso, now = new Date()) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return format(d, isSameDay(d, now) ? 'HH:mm' : 'dd/MM HH:mm');
};

export const laZalo = inbox => inbox?.channel_type === 'Channel::Api';

/**
 * Trang Zalo mà nút "Cuộc trò chuyện mới" thao tác (inbox thô, snake_case).
 * Phạm vi đang xem chỉ MỘT trang và là Zalo → trang đó.
 * Phạm vi nhiều trang → chỉ khi đang mở hội thoại của trang Zalo; không gộp trang.
 * selectedIds rỗng = đang xem tất cả trang.
 */
export const hopThuZaloChoNut = (
  inboxes = [],
  selectedIds = [],
  inboxIdDangMo = null
) => {
  const ids = (selectedIds ?? []).map(Number);
  const phamVi = ids.length
    ? inboxes.filter(i => ids.includes(Number(i.id)))
    : inboxes;
  if (phamVi.length === 1) return laZalo(phamVi[0]) ? phamVi[0] : null;

  const dangMo = inboxes.find(i => Number(i.id) === Number(inboxIdDangMo));
  return laZalo(dangMo) ? dangMo : null;
};

/**
 * Chuẩn hoá SĐT từ PhoneNumberInput ("+840394…" hoặc "+84394…") thành "84394…".
 * Trả '' nếu chưa đủ 9 số sau mã nước — chưa tìm.
 */
export const chuanHoaSdt = value => {
  let so = String(value ?? '').replace(/\D/g, '');
  if (so.startsWith('840')) so = `84${so.slice(3)}`;
  else if (so.startsWith('0')) so = `84${so.slice(1)}`;
  const quocNoi = so.startsWith('84') ? so.slice(2) : so;
  return quocNoi.length >= 9 ? so : '';
};

/** Lọc bạn bè theo tên, không phân biệt dấu/hoa thường. */
export const locBanBe = (banBe = [], tuKhoa = '') => {
  const tu = boDau(tuKhoa).trim().toLowerCase();
  if (!tu) return banBe;
  return banBe.filter(b => boDau(b.ten).toLowerCase().includes(tu));
};

/** Câu lời mời mặc định của trang, trống thì câu dự phòng. */
export const loiMoiMacDinh = (cauHinh, tenHopThu, t) =>
  cauHinh?.zalo_loi_moi_ket_ban?.trim() ||
  t(`${P}.LOI_MOI_MAC_DINH`, { ten: tenHopThu || '' });
